export function Column({
  children,
  sm = 12,
  md = 12,
  lg = 12,
  xl = 12,
  xxl = 12,
  offset = 0,
  color = null,
}) {
  return (
    <div
      className={`col-sm-${sm} col-md-${md} col-lg-${lg} col-xl-${xl} col-xxl-${xxl} offset-${offset} bg-${color}`}
    >
      {children}
    </div>
  );
}
